import React from 'react';
import { Search, Eye, EyeOff, ArrowLeft } from 'lucide-react';

const SearchHeader = ({ 
  searchTerm, 
  onSearchChange, 
  showPrices, 
  onTogglePrices,
  onBack 
}) => (
  <div className="sticky top-0 bg-white dark:bg-gray-800 border-b dark:border-gray-700 z-10">
    <div className="p-4">
      <div className="flex items-center mb-4">
        <button 
          className="mr-3 text-gray-900 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 p-1 rounded-lg"
          onClick={onBack}
        >
          <ArrowLeft className="w-6 h-6" />
        </button>
        <h1 className="text-xl font-bold text-gray-900 dark:text-white">Nueva Venta</h1>
      </div>

      <div className="space-y-3">
        <div className="relative">
          <Search className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 dark:text-gray-500" />
          <input
            type="text"
            placeholder="Buscar lotes..."
            className="w-full pl-10 pr-4 py-2 border dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
        
        <button 
          onClick={onTogglePrices}
          className="flex items-center text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 transition-colors"
        >
          {showPrices ? (
            <>
              <EyeOff className="w-4 h-4 mr-1" />
              Ocultar precios
            </>
          ) : (
            <>
              <Eye className="w-4 h-4 mr-1" />
              Mostrar precios
            </>
          )}
        </button>
      </div>
    </div>
  </div>
);

export default SearchHeader; 